import { isDefined } from "@ls/js-utils";

export default class AttributeDefinition {
  static getDefault = () =>
    new AttributeDefinition({
      attribute: "name",
    });

  #attribute;

  constructor(props = {}) {
    const { attribute } = props;
    this.#attribute = attribute;
  }

  get attribute() {
    return this.#attribute;
  }

  setAttribute = (value) => new AttributeDefinition({ attribute: value });

  get complete() {
    return isDefined(this.attribute);
  }
  get key() {
    return this.#attribute;
  }

  copy = () => {
    return {
      attribute: this.attribute,
    };
  };
}
